import React, {Component} from 'react';
import {NavBar, SearchBar, Toast,Modal} from 'antd-mobile';
import {connect} from "react-redux";
import BMap from "BMap";
import moment from 'moment';
import {changeAddress,getcharge,translate} from '../../../service/homeService';
import "./style.less";
const mapImg = require('../../../common/image/position.png');
let map,point,gc,poi,ls;
var isBack=false;
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class ChangeAddress extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            errorTips: [
                '',
                '您当前所在位置超出接送范围！',
                '超出接送范围，请重新选择！',
                '无法精确定位到当前位置，请重新选择！',
            ],
            curTips: '',
            isError: false,
            address:'',
            searchValue:'',
            poiList:[],
            poiListFlag:false,
            siteCityFlag:true,
            cityModal:false,
            modalType:'',
            citySearch:'',
            cityData:[],
            endStation:[],
            passStation:[],
            haveChangeAddress:false,//是否拖拽过地图，默认未拖拽过
            addressCanBeUse:false,//地址是否可用 more不可用
            endPoint:'',
            endCity:'',
            showModal:false,
            charge:'',
            haveChanged:false,
            
        };

        this._returnPayResult = this._returnPayResult.bind(this);
    }


    componentWillMount(){
        isBack = false;
    }


    componentDidMount() {
        //需要在这里根据上个页面传递过来的起止点设置为地图中心点。并将初始的上下车地址设置为起止点地址。
        this.setState({address:this.props.location.startPointName ? this.props.location.startPointName :this.props.location.endPointName });
        const self = this;
        map = new BMap.Map('mapContainer');
        gc = new BMap.Geocoder();
        if(this.props.location.startPoint){
            point = this.props.location.startPoint.split(","); 
            // map.centerAndZoom(new BMap.Point(parseFloat(point[0]),parseFloat(point[1])), 15);
            this.convertjwd(point[1],point[0],5,(r)=>{
                map.centerAndZoom(new BMap.Point(r.split('_')[1],r.split('_')[0]), 18);
            })
        }
        if(this.props.location.endPoint){
            point = this.props.location.endPoint.split(","); 
            console.log(point)
            // map.centerAndZoom(new BMap.Point(parseFloat(point[0]),parseFloat(point[1])), 15);
            this.convertjwd(point[1],point[0],5,(r)=>{
                console.log(r)
                map.centerAndZoom(new BMap.Point(r.split('_')[1],r.split('_')[0]), 18);
            })
        }
        ls = new BMap.LocalSearch(map, {
            onSearchComplete: (res) => {
                let s = [];
                if (res) {
                    for (var i = 0; i < res.getCurrentNumPois(); i++) {
                        s.push(res.getPoi(i))
                    }
                    self.setState({
                        poiList: s,
                    });
                }
            },
        });
        // ls = new BMap.LocalSearch(map, {
        //     onSearchComplete: (res) => {
        //         if (res && res.Kr) {
        //             self.setState({
        //                 poiList: res.Kr
        //             });
        //         }
        //     },
        // });
        map.addEventListener('dragend', function (e) {
                let centerPoint = map.getCenter();
                gc.getLocation(centerPoint, function (res) {
                    if (res.surroundingPois.length) {
                        let firstPoint = res.surroundingPois[0];
                        self.setData(self, firstPoint.title, firstPoint.point.lng, firstPoint.point.lat, false, 0,true,true);
                    } else {
                        self.setData(self, '', '', '', true, 3,true,false);
                    }
                });
        });

    }
    convertjwd(lat,lng,type,callback){
        let params = {
            token:this.props.userInfo.token,
            data:{
                position:lat+'_'+lng,
                type:type,
            }
        }
        translate(params).then((res) => {
            if (res.data.code === '0000') {
                return callback(res.data.data)
            }else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }else {
                Toast.info(res.data.msg);
            }
        })
    }
    _returnPayResult(datas){
        console.log('_returnPayResult',datas)
        //返回支付结果
        var state = this.props.history.location.data;
        if(!isBack){//做返回标识，防止递归无限返回导致内存栈溢出
            isBack = true;
            state.returnData(datas);
            this.props.history.goBack(-1);
        }
    }

    selPoi(res){
        let props = this.props.location.datas;
        if(props.type == 'start'){
            map.setCenter(res.point);
            this.setData(this, res.title, res.point.lng, res.point.lat, false, 0,false,false);
            this.setState({poiListFlag:false,searchValue:'',poiList: []});
        }else{
            map.setCenter(res.point);
            this.setData(this, res.title, res.point.lng, res.point.lat, false, 0,false,false);
            this.setState({poiListFlag:false,searchValue:'',poiList: []});
        }
    }
    searchChange=(value)=>{
        this.setState({ searchValue:value ,poiListFlag:true,haveChanged:true});
        this.tabDOM.scrollTop = 0;
        ls.search(value);
    };
    onClear=()=>{
        this.setState({poiList: [],poiListFlag:false,searchValue:'',siteCityFlag:false});
    };


    onClose = () => {
        this.setState({
           showModal:false
        });
    };


    toggleCity=()=>{
        this.setState({poiList: [],searchValue:'',cityModal: true,siteCityFlag:true,poiListFlag:false});
        const params = {
            keyWords: '',
            // modalType:props.type,
            modalType:'start',
        };

    };
    /**
     * evented 是否拖拽过
     * canbeUsed 地址是否可用
     */
    setData = (self, title, lng, lat, boolean, index,evented,canbeUsed) => {
        self.setState({
            address: title,
            isError: boolean,
            curTips: self.state.errorTips[index],
            addressCanBeUse:canbeUsed,
            haveChangeAddress:evented
        });
        poi = {
            lng: lng,
            lat: lat,
            address: title,
        };//经纬度以及地点
    };

    goSelClass = () => {
        console.log(poi)
        console.log(this.state.haveChangeAddress)
        console.log(this.state.haveChanged === true)
        if(this.state.address === ''){
            Toast.info('请先选择可用地址！')
            return
        }
        //用户没有拖动过地址，也没有输入地址，证明用户没有修改地址
        if(this.state.haveChangeAddress === false && this.state.haveChanged === false){
            Toast.info('请先拖动或者输入地址修改地址！')
            return
        }   
        this.setState({
            showModal:true
        })
        //开始计算差价
        const props = this.props.location.datas;
        this.convertjwd(poi.lat,poi.lng,6,(r)=>{
            let params = {
                token:this.props.userInfo.token,
               
                "data":{
                    "intercityOrderId":this.props.history.location.orderId,
                    "endAddressLocation":r,
                    "changeType":props.type === 'start' ? 0 : 1
                }
            }
            Toast.loading("正在加载",0);
            getcharge(params).then((res) => {
                console.log(res)
                if (res.data.code === '0000') {
                    Toast.hide();
                    this.setState({
                        charge:res.data.data == null ||  res.data.data == 0 ? 0 : res.data.data
                    })
                    
                }
                else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                }
                else {
                    Toast.info(res.data.msg);
                }
            })
        })
        
    }
    goBack = () => {
        //请求上下车修改地址接口
        const props = this.props.location.datas;
        if(!poi){
            Toast.fail('地址不存在');
            return;
        }
        this.convertjwd(poi.lat,poi.lng,6,(r)=>{
            console.log(r)
            let params = {
                token:this.props.userInfo.token,
            
                "data":{
                    "intercityOrderId":this.props.history.location.orderId,
                    "operatorType":1,
                    "sourceChange":1,
                    "endAddress":poi.address,
                    "endAddressLocation":r,
                    "changeType":props.type === 'start' ? 0 : 1
                }
            }
            Toast.loading("正在加载",0);
            changeAddress(params).then((res) => {
                console.log('gobackResult->',res);
                if (res.data.code === '0000') {
                    Toast.hide();
                    let timestamp = (new Date()).getTime();//获取当前时间戳
                    let addresschangeTime = moment(res.data.data.addresschangeTime).valueOf();//订单生成的时间
                    let timeArea = moment(addresschangeTime).add(600, 'seconds').format('x') - timestamp;//订单剩余支付秒数
                    var state = this.props.history.location.datas;
                    let flag;
                    // return
                    if(this.state.charge == 0){
                        if(this.state.haveChangeAddress){
                            //把确认好的经纬度传过去
                            state.returnData({
                                type:state.type,
                                address:this.state.address,
                                point:poi,
                                endCity:this.state.endCity,
                                endStationId:this.state.endStationId
                            });
                            
                        }else{
                            state.returnData({
                                type:state.type,
                                address:this.state.address,
                                point:this.props.location.startPoint ?this.props.location.startPoint :this.state.endPoint,
                                endCity:this.state.endCity,
                                endStationId:this.state.endStationId
                            });
                        }
                        this.props.history.goBack();
                    }else{
                        if(this.state.haveChangeAddress){
                            flag = 0;
                            
                        }else{
                            flag = 1;
                        }
                        var data = {
                            image:res.data.data.imgPath,
                            addresschangeId:res.data.data.addresschangeId,
                            amount:res.data.data.spreadPrice,
                            type:state.type,
                            address:this.state.address,
                            point:flag == 0 ? poi : (this.props.location.startPoint ? this.props.location.startPoint :this.state.endPoint),
                            addressChangeAfter:res.data.data.addressChangeAfter,
                            addressChangeBefore:res.data.data.addressChangeBefore,
                            timeArea:timeArea,
                        };
                        var historyData = {
                            pathname:'/TwoDimensionalCode',
                            data:data,
                            seatId:this.props.history.location.seatId,
                        };
                        data.returnData = this._returnPayResult.bind(this);
                        this.props.history.push(historyData);
                    }
                   
                }
                else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                }
                else {
                    Toast.info(res.data.msg);
                }
            })
        })
        
        
       
    }

    render(){
        var props = this.props.location.datas;
        const locationDatas = this.props.location;
        if(!props){
            props = {};
        }

        var addressStr = '';
        var addressStrLocation = '';
        var  addressLocation =''
        if(typeof locationDatas != 'undefined' 
            && typeof locationDatas.endStation != 'undefined'
            && locationDatas.endStation.length > 0){
                addressLocation = locationDatas.endStation[0];
                addressStr = addressLocation.city;
                addressStrLocation = addressLocation.location;
        }
        return(
            <div className="ChangeAddress">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />}
                >{props.type == 'start' ? '上车地址' : '下车地址'}</NavBar>
                <div id="mapContainer"/>
                {
                    this.state.isError ? <div className="errTips"><span>{this.state.curTips}</span></div> : null
                }
                <img className="mapIcon" src={mapImg} alt=""/>
                <div className="topBar">
                {
                    locationDatas.startCity ? 
                        (<div className="selCity"><span style={{paddingRight: "10px"}}>{locationDatas.startCity}</span></div>) 
                        :
                        (<div className="selCity" onClick={this.toggleCity}><span style={{paddingRight: "10px"}}>{locationDatas.endCity}</span></div>)
                }
                    <SearchBar
                        className="searchBar"
                        value={this.state.searchValue}
                        placeholder={props.type == 'start' ? '哪儿上车？' : '哪儿下车？'}
                        onChange={this.searchChange}
                        showCancelButton={false}
                        onCancel={this.onClear}
                        onClear={this.onClear}
                    />
                </div>
                <div className="bottom">
                   <div className="addressText">
                       <i className="icon iconfont icondaixiadanchufadi"/>
                       <div>{this.state.address ? this.state.address : props.address}</div>
                   </div>
                    <button onClick={()=>this.goSelClass()}>{props.type == 'start' ? '确认上车地址修改' : '确认下车地址修改'}</button>
                </div>

                <div className="poiList" style={this.state.poiListFlag == false  ? {height:'0'} : {height:'100%'}} ref={dom => {this.tabDOM = dom}}>
                    <div>
                       {/*  <div className="history"><i className="icon iconfont iconlishi"/>历史记录</div>
                        <div className="historyText">
                            文山市七花广场同德街大胜酒店的发防晒霜的说法是
            </div> */}
                        <div className="mapSel" onClick={this.onClear}><i className="icon iconfont iconditushangxuandian"/>在地图上选点</div>
                    </div>

                    {
                        this.state.poiList.length > 0 ? (
                            <div className="list">
                                {
                                    this.state.poiList.map((res, i) => (
                                        <div className="item"  key={i}  onClick={() => this.selPoi(res)} >
                                            <i className="icon iconfont icondituliebiaotubiao"/>
                                            <div>
                                                <div>{res.title}</div>
                                                <span>{res.address}</span>
                                            </div>
                                        </div>

                                    ))
                                }
                            </div>
                        ): <div className='tishi'>请输入搜索内容</div>
                    }

                </div>
                <Modal
                    popup
                    key={5}
                    closable
                    visible={this.state.showModal}
                    animationType="slide-up"
                    maskClosable={true}
                    onClose={()=>this.onClose()}
                >
                    <div className="btnBox">
                        <div className="wordtip">修改地址产生差价：<span style={{color:"#F66D53"}}>￥{this.state.charge ? this.state.charge: 0}</span></div>
                        <div className="buyTicket" style={{marginTop:"20px"}} onClick={()=>this.goBack()}>{this.state.charge == 0 ? '确认修改' : '扫码支付'}</div>
                    </div>
                </Modal>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Home/ChangeAddress/index.js